export const ACTIVE_BTN_CLASS = `product__form-size--checked`;
